<template>
    <div class="tc-select-case-category-card"
         @click="$emit('click')">
        <img class="tc-select-case-category-card-img"
             :src="categoryImage">
        <div class="tc-select-case-category-card-body">
            <div class="tc-select-case-category-card-body-label">
                {{categoryName}}
            </div>
            <div class="tc-select-case-category-card-body-text">
                {{categoryDescription}}
            </div>
            <div class="tc-select-case-category-card-body-scroll-down-line">
                <div class="tc-select-case-category-card-body-scroll-down">
                    <SVGScrollDown/>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import SVGScrollDown from '@/UI/SVG/SVGScrollDown.vue';

export default {
    name: 'SelectCaseCategoryCard',
    components: {
        SVGScrollDown,
    },
    emits: [
        'click',
    ],
    props: [
        'categoryId',
        'categoryName',
        'categoryDescription',
        'categoryImage',
    ],
};
</script>

<style scoped lang="scss">
.tc-select-case-category-card {
    display: flex;
    width: 100%;
    height: 145px;
    flex-direction: row;
    gap: 10px;
    padding: 15px;
    cursor: pointer;
    box-sizing: border-box;
    background-color: #ffffff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}

.tc-select-case-category-card-img {
    height: 100%;
    width: 100px;
    object-fit: contain;
    display: flex;
    flex-grow: 0;
    flex-shrink: 0;
    background-color: #ffffff;
}

.tc-select-case-category-card-body {
    padding: 5px 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
}

.tc-select-case-category-card-body-label {
    font-size: 16px;
    font-weight: 600;
}

.tc-select-case-category-card-body-text {
    font-size: 14px;
    padding-top: 10px;
}

.tc-select-case-category-card-body-scroll-down-line {
    width: 100%;
    height: 100%;
    justify-content: flex-end;
    align-items: flex-end;
    display: flex;
    color: #33333380;
    transition: 0.3s ease all;
}

.tc-select-case-category-card:hover .tc-select-case-category-card-body-scroll-down-line{
    color: #333333;
}

</style>
